var MedBoots = function (quality) {
  return {
    slot: 'boots',
    type: 'med',
    quality: quality,
    armorClass: Math.round(5 + quality * 22),
    dexterity: Math.round(1 + quality * 4),
  };
};
module.exports = MedBoots;
